//import toonShade from "../snippets/toonShade";

import hashWithoutSine from "../snippets/hashWithoutSine";
import highLowEncoding from "../snippets/highLowEncoding";

export default `
precision highp float;

uniform vec4 color;
uniform vec4 darkColor;
uniform float time;
uniform sampler2D trails;
uniform sampler2D imprint;
uniform vec2 texelSize;
uniform vec2 lightPos;
uniform vec2 cameraPosition;
uniform float cameraScale;
uniform float trailUvScaler;
uniform vec2 trailUvOffset;

varying vec2 vUv;

float DistortionScaler = 10.0;

${highLowEncoding()}

int mod(int x, int m) {
  return int(mod(float(x), float(m)));
}

${hashWithoutSine()}

float random5(vec3 co) {
	return hash13(co);
}


float random4(float x, float y, float z) {
	return random5(vec3(x, y, z));
}

float random4(int x, int y, int z) {
	return random4(float(x), float(y), float(z));
}

//Smoothstep curve, nearly identical to the cosine curve (1 - cos(x * PI)) / 2 but without the cos, which is slow on some GPUs
float interpolation(float a, float b, float x) {
	float f = x * x * (3.0 - 2.0 * x);
	return mix(a, b, f);
}

float tricosine(vec3 coordFloat) {
	vec3 coord0 = vec3(floor(coordFloat.x), floor(coordFloat.y), floor(coordFloat.z));
	vec3 coord1 = vec3(coord0.x+1.0, coord0.y+1.0, coord0.z+1.0);
	float xd = coordFloat.x - coord0.x;
	float yd = coordFloat.y - coord0.y;
	float zd = coordFloat.z - coord0.z;
	float c00 = interpolation(random4(coord0.x, coord0.y, coord0.z), random4(coord1.x, coord0.y, coord0.z), xd);
	float c10 = interpolation(random4(coord0.x, coord1.y, coord0.z), random4(coord1.x, coord1.y, coord0.z), xd);
	float c01 = interpolation(random4(coord0.x, coord0.y, coord1.z), random4(coord1.x, coord0.y, coord1.z), xd);
	float c11 = interpolation(random4(coord0.x, coord1.y, coord1.z), random4(coord1.x, coord1.y, coord1.z), xd);
	float c0 = interpolation(c00, c10, yd);
	float c1 = interpolation(c01, c11, yd);
	float c = interpolation(c0, c1, zd);
	
	return c;
}

float nearestNeighbour(vec3 coordFloat) {
	return random4(int(floor(coordFloat.x)), int(floor(coordFloat.y)), int(floor(coordFloat.z)));
}

float helper(float x, float y, float z, float resolution) {
	x = (x+1.0)/2.0*resolution;
	y = (y+1.0)/2.0*resolution;
	z = (z+1.0)/2.0*resolution;
	
	vec3 coordFloat = vec3(x, y, z);
	float interpolated = tricosine(coordFloat);
	return interpolated*2.0 - 1.0;
}

float scalarField(float x, float y, float z) {
	
	float height = 0.5;

	// float resolution1 = 4.0;
	// float level1 = helper(x, y, z, resolution1);
	// height *= 1.0 + level1*0.8;

	float resolution2 = 16.0;
	float level2 = helper(x, y, z, resolution2);
	height *= 1.0 + level2*0.8;

	float resolution3 = 32.0;
	float level3 = helper(x, y, z, resolution3);
	height *= 1.0 + level3*0.4;

	float resolution4 = 64.0;
	float level4 = helper(x, y, z, resolution4);
	height *= 1.0 + level4*0.2;

	float resolution5 = 128.0;
	float level5 = helper(x, y, z, resolution5);
	height *= 1.0 + level5*0.1;
	
	return height; 
}

void main() {
	vec2 imprintUv = (vUv + trailUvOffset) * (trailUvScaler);
	vec4 imprintColor = texture2D(trails, imprintUv);

	float scale = 1.0/cameraScale;
	float x = vUv.x * scale;
	float y = vUv.y * scale;
	x -= cameraPosition.x;
	y -= cameraPosition.y;

	float noiseHeight = scalarField(x, y, time);
	float height = noiseHeight;
	float colorHeight = height;

	#define THRESHOLD 0.75
	float seperation = 0.015; //used to multiply by cameraScale but working well here
	float lowerBound = THRESHOLD - seperation;
	float upperBound = THRESHOLD + seperation;
	if(height < lowerBound || height > upperBound) {
		if (height < THRESHOLD) height = lowerBound;
		else height = upperBound;
	}

	float imprintHeight = highLowDecode(imprintColor.gb) * insideUv(imprintUv);

	//Keep trails visible, bypassing thresholds and regardless of how faded it is until its gone
	if(imprintHeight > 0.0) {
		height = 1.0; //trails darker than even the darkest background
	}
	//Lower bound because of the flip that comes later, see comment below about normalize call
	//height = mix(height, lowerBound, imprintHeight);
	//height = mix(height, 1.0, imprintHeight);

	colorHeight = mix(colorHeight, 0.0, imprintHeight);

	//Eggagerate darker colors
	if (colorHeight < THRESHOLD / 2.0) colorHeight *= 0.55;

	vec4 result = vec4(height, 0.0, colorHeight, 1.0);

	//This step creates a sort of stepped texture on the flat water and inverts the colors/heights
	//I don't know why it works, I just did it accidentally and it looked cool. So keeping it for now.
	result = normalize(result);

	gl_FragColor = result;
}

`;